// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  configLeaveTenurePolicy: {},
  configLeavePeriodStartDate: {},
}

export const mutations = {
  SET_CONFIG_LEAVE_TENURE_POLICY(state, configLeaveTenurePolicy) {
    state.configLeaveTenurePolicy = configLeaveTenurePolicy
  },
  SET_CONFIG_LEAVE_PERIOD_START_DATE(state, configLeavePeriodStartDate) {
    state.configLeavePeriodStartDate = configLeavePeriodStartDate
  },
}

export const actions = {
  fetchConfigLeaveTenurePolicy({ commit }, payload) {
    return ApiService.fetchConfigLeaveTenurePolicy(payload)
      .then((res) => {
        const configLeaveTenurePolicy = res.data
        commit('SET_CONFIG_LEAVE_TENURE_POLICY', configLeaveTenurePolicy)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchConfigLeavePeriodStartDate({ commit }, payload) {
    return ApiService.fetchConfigLeavePeriodStartDate(payload)
      .then((res) => {
        const configLeavePeriodStartDate = res.data
        commit('SET_CONFIG_LEAVE_PERIOD_START_DATE', configLeavePeriodStartDate)
      })
      .catch((error) => {
        throw error
      })
  },
  editConfigLeaveTenurePolicy({ commit }, payload) {
    return ApiService.editConfigLeaveTenurePolicy(payload)
      .then((res) => {
        const configLeaveTenurePolicy = res.data
        commit('SET_CONFIG_LEAVE_TENURE_POLICY', configLeaveTenurePolicy)
      })
      .catch((error) => {
        throw error
      })
  },
  editConfigLeavePeriodStartDate({ commit }, payload) {
    return ApiService.editConfigLeavePeriodStartDate(payload)
      .then((res) => {
        const configLeavePeriodStartDate = res.data
        commit('SET_CONFIG_LEAVE_PERIOD_START_DATE', configLeavePeriodStartDate)
      })
      .catch((error) => {
        throw error
      })
  },
}
